export default __webpack_public_path__ + "static/media/cloud1.d5dc4586.png";